import { SearchMode } from 'cpool-constants';
import { useTranslation } from 'react-i18next';

import { useSearch } from './contexts/SearchContext';

export const SearchModeSwitch = () => {
    const { t } = useTranslation();
    const { searchMode, switchSearchMode } = useSearch();

    return (
        <div className="text-xs text-blue-dark flex gap-2 items-center">
            <span>{t('LEADS.SEARCH.MODE')}</span>
            <div className="bg-gray-100 p-0.5 rounded-md inline-flex">
                <button
                    onClick={() => switchSearchMode()}
                    className={`
          px-2 py-1 text-xs font-medium rounded transition-all duration-200
          ${searchMode === SearchMode.AND ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-700'}
        `}
                >
                    {t('LEADS.SEARCH.AND')}
                </button>
                <button
                    onClick={() => switchSearchMode()}
                    className={`
          px-2 py-1 text-xs font-medium rounded transition-all duration-200
          ${searchMode === SearchMode.OR ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-700'}
        `}
                >
                    {t('LEADS.SEARCH.OR')}
                </button>
            </div>
        </div>
    );
};
